var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button-group',[_c('a-popconfirm',{attrs:{"title":"确定删除吗"},on:{"confirm":_vm.destroy}},[_c('a-button',{attrs:{"type":"danger","icon":"delete","size":"small"}},[_vm._v("删除")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }